import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { useStateContext } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import { postRequest } from "../../../constants/api";
import { Container, Form, Row, Col } from "react-bootstrap";
import { Box, Button, ButtonGroup } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilSetting = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const [settingId, setSettingId] = useState("");
  const [namaPerusahaan, setNamaPerusahaan] = useState("");
  const [alamatPerusahaan, setAlamatPerusahaan] = useState("");
  const [kotaPerusahaan, setKotaPerusahaan] = useState("");
  const [kabupatenPerusahaan, setKabupatenPerusahaan] = useState("");
  const [provinsiPerusahaan, setProvinsiPerusahaan] = useState("");
  const [teleponPerusahaan, setTeleponPerusahaan] = useState("");
  const [direkturUtama, setDirekturUtama] = useState("");

  // COA
  const [coaKasKasir, setCoaKasKasir] = useState("");
  const [coaHutangPembelianBarang, setCoaHutangPembelianBarang] = useState("");
  const [coaPersediaan, setCoaPersediaan] = useState("");
  const [coaPiutangPenjualan, setCoaPiutangPenjualan] = useState("");
  const [coaPendapatanPenjualan, setCoaPendapatanPenjualan] = useState("");
  const [coaHargaPokokPenjualan, setCoaHargaPokokPenjualan] = useState("");
  const [coaPendapatanLainLain, setCoaPendapatanLainLain] = useState("");
  const [coaRugiSelisihOpname, setCoaRugiSelisihOpname] = useState("");
  const [labaRugiPeriodeBerjalan, setLabaRugiPeriodeBerjalan] = useState("");
  const [accountPembalance, setAccountPembalance] = useState("");

  // Group COA
  const [kodeGroupPendapatan, setKodeGroupPendapatan] = useState("");
  const [kodeGroupBiayaAtasPendapatan, setKodeGroupBiayaAtasPendapatan] =
    useState("");
  const [kodeGroupPengeluaranOperasional, setKodeGroupPengeluaranOperasional] =
    useState("");
  const [kodeGroupPendapatanLainLain, setKodeGroupPendapatanLainLain] =
    useState("");
  const [kodeGroupBiayaLainLain, setKodeGroupBiayaLainLain] = useState("");

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getSettingByCabang();
  }, []);

  const getSettingByCabang = async () => {
    setLoading(true);
    const response = await postRequest(`/lastSetting`, {}, navigate, dispatch);
    setSettingId(response.data.id);
    setNamaPerusahaan(response.data.namaPerusahaan);
    setAlamatPerusahaan(response.data.alamatPerusahaan);
    setKotaPerusahaan(response.data.kotaPerusahaan);
    setKabupatenPerusahaan(response.data.kabupatenPerusahaan);
    setProvinsiPerusahaan(response.data.provinsiPerusahaan);
    setTeleponPerusahaan(response.data.teleponPerusahaan);
    setDirekturUtama(response.data.direkturUtama);

    // COA
    setCoaKasKasir(response.data.coaKasKasir);
    setCoaHutangPembelianBarang(response.data.coaHutangPembelianBarang);
    setCoaPersediaan(response.data.coaPersediaan);
    setCoaPiutangPenjualan(response.data.coaPiutangPenjualan);
    setCoaPendapatanPenjualan(response.data.coaPendapatanPenjualan);
    setCoaHargaPokokPenjualan(response.data.coaHargaPokokPenjualan);
    setCoaPendapatanLainLain(response.data.coaPendapatanLainLain);
    setCoaRugiSelisihOpname(response.data.coaRugiSelisihOpname);
    setLabaRugiPeriodeBerjalan(response.data.labaRugiPeriodeBerjalan);
    setAccountPembalance(response.data.accountPembalance);

    // Group COA
    setKodeGroupPendapatan(response.data.kodeGroupPendapatan);
    setKodeGroupBiayaAtasPendapatan(response.data.kodeGroupBiayaAtasPendapatan);
    setKodeGroupPengeluaranOperasional(
      response.data.kodeGroupPengeluaranOperasional
    );
    setKodeGroupPendapatanLainLain(response.data.kodeGroupPendapatanLainLain);
    setKodeGroupBiayaLainLain(response.data.kodeGroupBiayaLainLain);
    setLoading(false);
  };

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const textRightSmall = {
    textAlign: screenSize >= 650 && "right",
    fontSize: "14px",
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <Container>
      <h3>Utility</h3>
      <h5 style={{ fontWeight: 400 }}>Setting</h5>
      <Container className="d-flex justify-content-center">
        <ButtonGroup variant="contained">
          <Button
            color="primary"
            startIcon={<EditIcon />}
            sx={{ textTransform: "none" }}
            onClick={() => {
              navigate(`/setting/${settingId}/edit`);
            }}
          >
            Ubah Setting
          </Button>
        </ButtonGroup>
      </Container>
      <hr />
      <Container>
        <Form>
          <Box sx={textFieldContainer}>
            <Box sx={textFieldWrapper}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Nama Perusahaan :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={namaPerusahaan} disabled readOnly />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Alamat Perusahaan :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={alamatPerusahaan}
                        disabled
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Kabupaten Perusahaan :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={kabupatenPerusahaan}
                        disabled
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Telepon Perusahaan :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={teleponPerusahaan}
                        disabled
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
            <Box sx={[textFieldWrapper, secondWrapper]}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Kota Perusahaan :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={kotaPerusahaan} disabled readOnly />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Provinsi Perusahaan :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={provinsiPerusahaan}
                        disabled
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Direktur Utama :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={direkturUtama} disabled readOnly />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
          </Box>

          <hr />
          <h5>COA</h5>
          <Box sx={textFieldContainer}>
            <Box sx={textFieldWrapper}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Coa Kas Kasir :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={coaKasKasir} disabled readOnly />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Coa Hutang Pembelian Barang :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={coaHutangPembelianBarang}
                        disabled
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Coa Persediaan :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={coaPersediaan} disabled readOnly />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Coa Piutang Penjualan :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={coaPiutangPenjualan}
                        disabled
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Coa Pendapatan Penjualan :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={coaPendapatanPenjualan}
                        disabled
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Coa Harga Pokok Penjualan :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={coaHargaPokokPenjualan}
                        disabled
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Coa Pendapatan Lain-Lain :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={coaPendapatanLainLain}
                        disabled
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Coa Biaya Lain-Lain :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={coaRugiSelisihOpname}
                        disabled
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Laba Rugi Periode Berjalan :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={labaRugiPeriodeBerjalan}
                        disabled
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Account Pembalance :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={accountPembalance}
                        disabled
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
            <Box sx={[textFieldWrapper, secondWrapper]}></Box>
          </Box>

          <hr />
          <h5>Group COA</h5>
          <Box sx={textFieldContainer}>
            <Box sx={textFieldWrapper}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Kode Group Pendapatan :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={kodeGroupPendapatan}
                        disabled
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Kode Group Biaya Atas Pendapatan :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={kodeGroupBiayaAtasPendapatan}
                        disabled
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Kode Group Pengeluaran Operasional :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={kodeGroupPengeluaranOperasional}
                        disabled
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Kode Group Pendapatan Lain-Lain :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={kodeGroupPendapatanLainLain}
                        disabled
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRightSmall}>
                      Kode Group Biaya Lain-Lain :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={kodeGroupBiayaLainLain}
                        disabled
                        readOnly
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
            <Box sx={[textFieldWrapper, secondWrapper]}></Box>
          </Box>
        </Form>
      </Container>
    </Container>
  );
};

export default TampilSetting;

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};
